import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from '@lyrical-toolkit/shared';
import LegalPage from './components/Legal/LegalPage';
import reportWebVitals from './reportWebVitals';

const LEGAL_ROUTES = {
  '/privacy': 'privacy',
  '/terms': 'terms',
  '/subscription-terms': 'subscription-terms',
  '/dmca': 'dmca',
};

function getRoot() {
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const legalSlug = LEGAL_ROUTES[path];
  if (legalSlug) {
    return <LegalPage slug={legalSlug} />;
  }
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {getRoot()}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
